import { render, staticRenderFns } from "./pre-fo-doctor.html?vue&type=template&id=25808a7e&scoped=true&external"
import script from "./pre-fo-doctor.js?vue&type=script&lang=js&external"
export * from "./pre-fo-doctor.js?vue&type=script&lang=js&external"
import style0 from "./pre-fo-doctor.scss?vue&type=style&index=0&id=25808a7e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25808a7e",
  null
  
)

export default component.exports